import { getNowInSeconds } from 'functions/getNowInSeconds';

const ONE_DAY_IN_SECOND = 24 * 3600;

// https://trialjectory.atlassian.net/browse/DEV-4989
export const prepareNotSureAnsweredQuestions = (rawValue) => {
  const now = getNowInSeconds();
  return Object.fromEntries(
    Object.entries(rawValue).filter(([, value]) => typeof value === 'number' && now - value < ONE_DAY_IN_SECOND),
  );
};
